var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 16.1625V5.25H5.25V2.25H13.1625V8.25H16.1625V16.1625H9.95625V12.9563H8.45625V16.1625H2.25ZM3.95625 14.4563H5.45625V12.9563H3.95625V14.4563ZM3.95625 11.4563H5.45625V9.95625H3.95625V11.4563ZM3.95625 8.45625H5.45625V6.95625H3.95625V8.45625ZM6.95625 11.4563H8.45625V9.95625H6.95625V11.4563ZM6.95625 8.45625H8.45625V6.95625H6.95625V8.45625ZM6.95625 5.45625H8.45625V3.95625H6.95625V5.45625ZM9.95625 11.4563H11.4563V9.95625H9.95625V11.4563ZM9.95625 8.45625H11.4563V6.95625H9.95625V8.45625ZM9.95625 5.45625H11.4563V3.95625H9.95625V5.45625ZM12.9563 14.4563H14.4563V12.9563H12.9563V14.4563ZM12.9563 11.4563H14.4563V9.95625H12.9563V11.4563Z",
    fill: "#909092"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/CompanyIcon.e12a055a73b94110962ae31d84fa4956.svg";
export { ForwardRef as ReactComponent };